import { useEffect, useState } from "react";
import Markdown from "react-markdown";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const DOCS = [
  { key: "terms", label: "Όροι Χρήσης" },
  { key: "privacy", label: "Πολιτική Απορρήτου" },
  { key: "cookies", label: "Πολιτική Cookies" },
];

const MD_CLS = "text-[15px] text-slate-700 leading-relaxed [&_h1]:font-display [&_h1]:text-2xl [&_h1]:font-extrabold [&_h1]:text-[#0b1442] [&_h1]:mb-4 [&_h2]:font-display [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-slate-900 [&_h2]:mt-6 [&_h2]:mb-2 [&_h3]:font-bold [&_h3]:mt-4 [&_h3]:mb-1 [&_p]:my-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:my-0.5 [&_a]:text-primary [&_a]:underline [&_strong]:text-slate-900";

export const LegalLinks = () => {
  const [open, setOpen] = useState(null);
  const [text, setText] = useState("");

  useEffect(() => {
    if (!open) return;
    setText("");
    fetch(`/legal/${open}.md`).then((r) => r.text()).then(setText).catch(() => setText("Το κείμενο δεν είναι διαθέσιμο."));
  }, [open]);

  return (
    <>
      <nav className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm text-slate-500" data-testid="footer-legal-links">
        {DOCS.map((d, i) => (
          <span key={d.key} className="flex items-center gap-3">
            {i > 0 && <span className="text-slate-300">|</span>}
            <button onClick={() => setOpen(d.key)} data-testid={`footer-legal-${d.key}`} className="hover:text-primary transition-colors">{d.label}</button>
          </span>
        ))}
      </nav>
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto rounded-2xl bg-white p-6 sm:p-8" data-testid="legal-dialog">
          <DialogTitle className="sr-only">{DOCS.find((d) => d.key === open)?.label}</DialogTitle>
          {text ? <div className={MD_CLS}><Markdown>{text}</Markdown></div> : <p className="text-slate-500">Φόρτωση...</p>}
        </DialogContent>
      </Dialog>
    </>
  );
};
